export default __webpack_public_path__ + "static/media/full16-9background.8fbf6972.jpg";